<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewBenefit"
            :searchFilters="searchFilters"
            @searchPage="searchBenefits"
            @resetFilters="resetFilters"
            @removeItem="removeBenefit"
            @removeSelectedItems="removeBenefits"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="benefitsList"
            :actions="actions"
            :idField="idField"
            :groupingKey=true
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveEmployeeBenefit" @handleReset="handleReset"
            />
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

export default{
    name: 'Employee_Benefits',
    components:{
        PageComponent, MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const loader = ref('none');
        const modal_loader = ref('none');
        const ledComponentKey = ref(0);
        const idField = 'employee_benefit_id';
        const addButtonLabel = ref('New Benefit');
        const addingRight = ref('Adding Employee Benefits');
        const removingRight = ref('Deleting Employee Benefits');
        const rightsModule = ref('HR');
        const title = ref('Employee Benefit Details');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const benefitsList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_left = ref('500px');
        const modal_width = ref('30vw');
        const ledgerID = ref('');
        const isEditing = computed(()=> store.state.Employee_Benefits.isEditing);
        const selectedBenefit = computed(()=> store.state.Employee_Benefits.selectedBenefit);
        const selectedLedger = computed(()=> store.state.Employee_Benefits.selectedLedger);
        const ledgerArray = computed(() => store.state.Ledgers.ledgerArr);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Date", key:"date"},
            {label: "Charge Mode", key:"charge_mode"},
            {label: "Charge Type", key:"charge_type"},
            {label: "Rate/Amount", key:"amount"},
            {label: "Posting Account", key:"posting_account_name"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Employee Benefit', rightName: 'Editing Employee Benefits'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Employee Benefit', rightName: 'Deleting Employee Benefits'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const searchFilters = ref([
        
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchAllLedgers = async() =>{
            await store.dispatch('Ledgers/fetchLedgers', {company:companyID.value})
        };
        const handleSelectedLedger = async(option) =>{
            await store.dispatch('Ledgers/handleSelectedLedger', option)
            ledgerID.value = store.state.Ledgers.ledgerID;
        };
        const clearSelectedLedger = async() =>{
            await store.dispatch('Ledgers/updateState', {ledgerID: ''});
            ledgerID.value = store.state.Ledgers.ledgerID;
        }
        const formFields = ref([]);
        const ledgerValue = computed(() => {
           return (selectedBenefit.value && selectedBenefit.value.posting_account && !ledgerID.value) ? selectedBenefit.value.posting_account.ledger_id : ledgerID.value;

        });
        const updateFormFields = () => {
            formFields.value = [     
                { type: 'date', name: 'date',label: "Effective Date", value: selectedBenefit.value?.date || '', required: true },
                { type: 'dropdown', name: 'regime',label: "Benefit Type", value: selectedBenefit.value?.benefit_type || '', placeholder: "", required: true, options: [{ text: 'House', value: 'House' }, { text: 'Car', value: 'Car' }] },
                { type: 'dropdown', name: 'charge_mode',label: "Charge Mode", value: selectedBenefit.value?.charge_mode || 'Higher', placeholder: "", required: true, options: [{ text: 'Higher', value: 'Higher' }, { text: 'Lower', value: 'Lower' }] },
                { type: 'dropdown', name: 'charge_type',label: "Charge Type", value: selectedBenefit.value?.charge_type || 'Rate', placeholder: "", required: true, options: [{ text: 'Rate', value: 'Rate' }, { text: 'Fixed Amount', value: 'Fixed Amount' }]},
                { type: 'number', name: 'amount',label: "Amount/Rate", value: selectedBenefit.value?.amount || 0, required: false },
                {  
                    type:'search-dropdown', label:"Posting Account", value: ledgerValue.value, componentKey: ledComponentKey,
                    selectOptions: ledgerArray, optionSelected: handleSelectedLedger, required: true,
                    searchPlaceholder: 'Select Posting Account...', dropdownWidth: '500px', updateValue: selectedLedger.value,
                    clearSearch: clearSelectedLedger
                },
            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            ledComponentKey.value += 1;
            ledgerID.value = '';
        }

        watch([selectedBenefit, selectedLedger], () => {
            if (selectedBenefit.value && selectedLedger.value) {
                ledComponentKey.value += 1;
                updateFormFields();
            }
            
        }, { immediate: true });
        
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createEmployeeBenefit = async() =>{
            showModalLoader();
            let formData = {
                date: formFields.value[0].value,
                benefit_type: formFields.value[1].value,
                charge_mode: formFields.value[2].value,
                charge_type: formFields.value[3].value,
                amount: formFields.value[4].value,
                posting_account: ledgerID.value,
                posting_account_id: ledgerID.value,
                company: companyID.value
            }
  
            errors.value = [];
            for(let i=1; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
            if(ledgerValue.value == ''){
                errors.value.push('error')
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Employee_Benefits/createEmployeeBenefit', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Benefit created successfully!');
                        handleReset();
                        ledComponentKey.value += 1;
                    } else {
                        toast.error('An error occurred while creating the Benefit.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Benefit: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchBenefits();
                }
            }
        }
        const updateEmployeeBenefit = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                employee_benefit_id: selectedBenefit.value.employee_benefit_id,
                date: formFields.value[0].value,
                benefit_type: formFields.value[1].value,
                charge_mode: formFields.value[2].value,
                charge_type: formFields.value[3].value,
                amount: formFields.value[4].value,
                posting_account: ledgerValue.value,
                posting_account_id: ledgerValue.value,
                company: companyID.value
            }

            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown'  && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(ledgerValue.value == ''){
                errors.value.push('error')
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Employee_Benefits/updateEmployeeBenefit', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        ledComponentKey.value += 1;
                        toast.success("Benefit updated successfully!");              
                    } else {
                        toast.error('An error occurred while updating the Benefit.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Benefit: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    store.dispatch("Employee_Benefits/updateState",{selectedBenefit:null})
                    searchBenefits();
                }             
            }
        }
        const saveEmployeeBenefit = () =>{
            if(isEditing.value == true){
                updateEmployeeBenefit();
            }else{
                createEmployeeBenefit();
            }
        }
        const removeBenefit = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    employee_benefit: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Employee_Benefits/deleteEmployeeBenefit',formData)
                    if(response && response.status == 200){
                        toast.success("Benefit Removed Succesfully");
                        searchBenefits();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Benefit: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Benefit") 
            }else{
                toast.error("Please Select A Benefit To Remove")
            }
        }
        const removeBenefits = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    employee_benefit: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Employee_Benefits/deleteEmployeeBenefit',formData)
                    if(response && response.status == 200){
                        toast.success("Benefit(s) Removed Succesfully");
                        searchBenefits();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Benefit: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select Benefit To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchBenefits = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                company_id: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/employee-benefits-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                benefitsList.value = response.data.results;
                store.commit('Employee_Benefits/LIST_BENEFITS', benefitsList.value)
                propResults.value = response.data;
                propArrLen.value = benefitsList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchBenefits(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            searchBenefits();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchBenefits();

        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchBenefits();

        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchBenefits();
        
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchBenefits();
     
        }
        const addNewBenefit = () =>{
            fetchAllLedgers();
            store.dispatch("Employee_Benefits/updateState",{selectedBenefit:null, selectedLedger:null});
            ledComponentKey.value += 1;
            handleReset();
            updateFormFields();
            propModalVisible.value = true;
            store.dispatch("Employee_Benefits/updateState",{isEditing:false})
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const benefitID = row['employee_benefit_id'];
                let formData = {
                    company: companyID.value,
                    employee_benefit: benefitID
                }
                await store.dispatch('Employee_Benefits/fetchEmployeeBenefit',formData)
                propModalVisible.value = true;
                flex_basis.value = '1/2';
                flex_basis_percentage.value = '50';

            }else if(action == 'delete'){
                const benefitID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    employee_benefit: benefitID
                }
                await store.dispatch('Employee_Benefits/deleteEmployeeBenefit',formData).
                then(()=>{
                    searchBenefits();
                })
            }else if(action == 'view'){
                console.log("VIEWING TAKING PLACE");
            }
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        };

        onBeforeMount(()=>{
            searchBenefits();
            fetchAllLedgers();
        })
        return{
            title, searchBenefits,resetFilters, addButtonLabel, searchFilters, tableColumns, benefitsList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewBenefit, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveEmployeeBenefit, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            removeBenefit, removeBenefits,addingRight,removingRight,rightsModule,selectSearchQuantity,selectedValue,
        }
    }
};
</script>